import PropTypes from 'prop-types';

import { DefaultTooltip } from 'twyne-new.ui'

import HeaderContainerGrid from '@/components/headerContainer/Grid';

import EmbedPathCode from './EmbedPathCode';
import UserProfileTool from './profileTool/ProfileTool';

const propTypes = {
  data: PropTypes.object,
};

export default function DashboardHeading({ data: site }) {
  return <HeaderContainerGrid title='User Profile Driven Paths'>
    <div className='justify-end items-center gap-4 flex'>
      <UserProfileTool />
      <DefaultTooltip content='Embeddable Path Code'>
        <EmbedPathCode siteId={site.id} />
      </DefaultTooltip>
    </div>
  </HeaderContainerGrid>
}

DashboardHeading.propTypes = propTypes
DashboardHeading.defaultProps = {}
